<template lang="html">
  <div class="rating-field">
    <ul class="rating">
      <li v-for="index in stars" :key="index" @click="enableRating(index)">
        <b-icon
          :type="userRated || mode === 'rate' ? 'is-info' : 'is-primary'"
          :icon="index <= currentRating ? 'star' : (index - 0.5) <= currentRating ? 'star-half-o' : 'star-o'"
        />
      </li>
    </ul>
    <expanding>
      <div class="buttons" v-show="showButton">
        <div class="placeholder-block"/>
        <button
          class="button is-small"
          :class="mode === 'save' ? 'is-loading is-white' : mode === 'success' ? 'is-successfull' : 'is-info is-outlined'"
          :disabled="mode === 'save'"
          @click="rate"
        >
          {{ $t('save') }}
        </button>

        <button
          class="button is-small is-black is-inverted"
          :disabled="mode === 'save' || mode === 'success'"
          @click="disableRating"
        >
          {{ $t('cancel') }}
        </button>
      </div>
    </expanding>
  </div>
</template>

<script>
import Expanding from 'vue-bulma-expanding'

export default {
  props: {
    stars: { type: [Number, String], default: 5 },
    rating: { type: [Number, String], default: 0 },
    ratings: { type: [Number, String], default: 0 },
    targetType: { type: String, required: true },
    targetId: { type: [Number, String], required: true },
    language: { type: String, default: window.__INIT_DATA.lang }
  },

  components: {
    Expanding
  },

  data(){
    return {
      showButton: false,
      mode: 'display',
      newRating: 5,
      userRating: 0,
      userRated: false,
      hasRated: false
    }
  },

  created(){
    this.loadMyRating()
  },

  watch: {
    '$user.authenticated': 'loadMyRating'
  },

  computed: {
    currentRating(){
      if(this.mode === 'display' && !this.userRated) return this.rating
      if(this.mode === 'rate') return this.newRating
      return this.userRating
    }
  },

  methods: {
    enableRating(rating){
      if(!this.$user.authenticated) return this.$user.showLoginDialog()
      if(this.mode === 'save') return
      this.mode = 'rate'
      this.showButton = true
      this.newRating = rating
      clearTimeout(this.$timeout)
    },

    disableRating(){
      this.mode = 'display'
      this.showButton = false
      clearTimeout(this.$timeout)
    },

    rate(){
      this.mode = 'save'
      this.userRated = true
      this.userRating = this.newRating
      this.hasRated = true

      this.$api.createRating(this.newRating, {target_id: this.targetId, target_type: this.targetType, language: this.language})
      .then(result => {
        if(result.success){
          this.mode = 'success'
          this.$timeout = setTimeout(() => {
            this.showButton = false
          }, 1000)
        }else{
          throw new Error('rating not successfull')
        }
      })
      .catch(e => {
        console.error(e)
        this.$toast.open({
          message: 'Beim Bewerten ist ein Fehler aufgetreten!',
          type: 'is-danger'
        })
        this.mode = 'rate'
      })
    },


    loadMyRating(){
      if(!this.$user.id) return
      if(this.userRated) return

      this.$api.getRating({target_id: this.targetId, target_type: this.targetType, language: this.language})
      .then(result => {
        if(result.rating){
          this.mode = 'display'
          this.userRating = result.rating
          this.userRated = true
        }
      })
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "save": "Speichern",
    "cancel": "Abbrechen"
  },
  "cs": {
    "save": "Uložit",
    "cancel": "zrušení"
  },
  "hu": {
    "save": "mentés",
    "cancel": "megszünteti"
  },
  "fr": {
    "save": "enregistrer",
    "cancel": "Annuler"
  }
}
</i18n>

<style lang="scss" scoped>
.rating-field{
  display: flex;
  flex-direction: column;
  align-items: center;

  .placeholder-block{
    height: 27px;
    width: 0px;
    display: inline-block;
  }

  ul.rating{
    display: flex;
    flex-direction: row;
    font-size: 18px;
    justify-content: center;

    li{
      cursor: pointer;
      margin: 0 1px;
    }
  }

  .buttons .button{
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rating/Field.vue